import { render, staticRenderFns } from "./consultationSingle.vue?vue&type=template&id=9d1d2344&"
import script from "./consultationSingle.vue?vue&type=script&lang=js&"
export * from "./consultationSingle.vue?vue&type=script&lang=js&"
import style0 from "./consultationSingle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports